import { FormControl } from './formcontrol'

export const FormInput = FormControl.extend({
    type: 'text',
    tagName: 'input',
})